module.exports = __webpack_public_path__ + "img/app.c3adc2bb.png";